module.exports = __webpack_public_path__ + "static/home-feature-2-v3-e41d426ded116162ae623ed6137c8f8f.svg";